//
// HeaderController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModelController";
import "../../models/view/Header";
import "./MediaContainerController";
import "./VisualController";
import "@sas-dvr/ltjs-commons/styles/StyleChain";
import "../../models/view/HeaderLocation";

var HeaderController = createModule("BIRD::HeaderController", ["BIRD::BIRDModelController"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getAllVisualControllers: [[1]],
        getModel: [1],
        getLocation: [4],
        getPromptBarStyleChain: [1],
        getMediaContainerController: [1],
    },
    {
        _create: [4,1,1],
    },
    ,
]);
export default HeaderController;
